<template>
  <tr
    :class="{
      'table__tr--background': validateIsInserted(),
      'table__tr--red': invoice.ESTAT === 'VENCIDO',
    }"
  >
    <!-- Número de documento -->
    <td style="position: relative">
      {{ invoice.BELNR }}
      <special-order-type-icon :order="invoice.AUART" />
    </td>
    <!-- Orden de compra -->
    <td>
      {{ !validateIsInserted() ? invoice.ORDCOM : '-' }}
    </td>
    <!-- Descargas -->
    <td>
      <div class="d-flex justify-content-center">
        <div class="d-flex align-items-start" style="width: 70px">
          <download-tooltip
            :invoice="invoice.BELNR"
            color="red"
            tooltip-text="Descargar PDF"
            :type="1"
            @download="getPDFXMLInvoice"
          />

          <download-tooltip
            :invoice="invoice.BELNR"
            color="blue"
            tooltip-text="Descargar XML"
            :type="2"
            @download="getPDFXMLInvoice"
          />
        </div>
      </div>
    </td>
    <!-- Tipo de documento -->
    <td>
      <div class="d-flex align-items-center">
        <div v-if="!validateIsInserted()" style="min-width: 30px">
          <v-icon
            v-if="invoice.DETFAC !== undefined && invoice.DETFAC.length > 0"
            small
            color="#5600e8"
            @click="$emit('actionButton')"
          >
            {{ invoice.isOpen ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
          </v-icon>
        </div>
        <span class="w-100">{{ invoice.TIPO }}</span>
        <div style="min-width: 32px">
          <span
            v-if="invoice.AUGRU"
            class="badge rounded-pill"
            style="background: #306b75"
            >{{ invoice.AUGRU }}</span
          >
        </div>
      </div>
    </td>
    <!-- Fecha de documento -->
    <td>{{ invoice.BUDAT }}</td>
    <!-- Fecha de Vencimiento -->
    <td>{{ !validateIsInserted() ? invoice.FVENC : '-' }}</td>
    <!-- Días vencidos -->
    <td>{{ !validateIsInserted() ? invoice.DVENC : '-' }}</td>
    <!-- Monto -->
    <td>${{ invoice.DMBTR | formatCurrency }}</td>
    <!-- Saldo sin vencer -->
    <td>
      {{
        !validateIsInserted() ? `$${formatCurrency(invoice.por_vencer)}` : '-'
      }}
    </td>
    <!-- Saldo vencido -->
    <td>
      {{ !validateIsInserted() ? `$${formatCurrency(invoice.vencido)}` : '-' }}
    </td>
  </tr>
</template>

<script>
  import DownloadTooltip from './DownloadTooltip.vue';
  import axios from '@/plugins/axios';
  import SpecialOrderTypeIcon from '@/components/SpecialOrderTypeIcon.vue';

  export default {
    components: { DownloadTooltip, SpecialOrderTypeIcon },
    props: {
      invoice: {
        type: Object,
        required: true,
      },
    },
    methods: {
      validateIsInserted() {
        return this.invoice.inserted;
      },
      async getPDFXMLInvoice(invoice, type) {
        try {
          const response = await axios.post('/InvoicePDFXML', {
            invoice: invoice,
            type: type,
          });
          this.url = response.data;
          window.open(this.url, '_blank');
        } catch (error) {
          this.$toast.error('Ocurrió un error al abrir el documento');
        }
      },
      formatCurrency(value) {
        return this.$options.filters.formatCurrency(value);
      },
    },
  };
</script>

<style scoped>
  .table__tr--red {
    color: red;
  }
  .table__tr--background td {
    background: #f2f2f2;
  }
</style>
